import {ApplicationEvent} from './application-event.model';
import {ApplicationEventType, ApplicationSearchEventSource} from '../constants';

export class CategoryPageViewedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CategoryPageViewed;

  constructor(private categoryName: string,
              private applicationSearchEventSource: ApplicationSearchEventSource,
              private hasFilters?: boolean,
              private expiredPromo?: boolean,
              private totalItems?: number) {}

  getPayload(): CategoryPageApplicationEventPayload {
    return {
      GA360_query: this.categoryName,
      source: this.applicationSearchEventSource,
      expiredPromoTag: this.expiredPromo,
      hasFilters: this.hasFilters,
      GA360_regularResults: this.totalItems,
      label: this.categoryName
    };
  }
}

export interface CategoryPageApplicationEventPayload {
  GA360_query: string;
  source: ApplicationSearchEventSource;
  label: string;
  expiredPromoTag?: boolean;
  hasFilters?: boolean;
  GA360_regularResults?: number;
}
